<div class="login-wrapper login">
    <div class="login-inner">
        <p class="voilet-text fw-900 f-26 text-center">Login</p>
        <div class="w80 m-auto mt-30"> 
            <form  [formGroup]="form" class="example-form">
                <p class="f-16 regularfont greyfont">Enter your phone number or email</p>
                <mat-form-field class="example-full-width" appearance="outline" class="w100">
                    <input  required matInput formControlName="mobileOrEmail" 
                      autocomplete="off" style="text-align: left;" >                        
                  </mat-form-field>
                  <p class="f-16 regularfont greyfont">Enter password</p>
                  <mat-form-field class="example-full-width" appearance="outline" class="w100">
                      <input type="password" required matInput formControlName="password" 
                        autocomplete="off" style="text-align: left;" >                        
                    </mat-form-field>

            </form>
            <div class="row  login-btn mt-30 mview">
                <div class="col-md-12  btn-style">
                    <div class="col-md-6 " style="padding-left: 0;" >
                        <button mat-raised-button color="primary" class="f-18 cPointer flex " 
                        (click)="submit()" [disabled]="!form.valid">Login</button>
                        
                    </div>
                </div>               
            </div>
        </div> 
    </div>
</div>